module.exports = __webpack_public_path__ + "img/category.3baacaef.svg";